<template>
  <section class="hero" aria-labelledby="welcome-hero-title">
    <div class="hero__content">
      <span class="hero__tag">Bienvenido</span>

      <div class="hero__text">
        <h1 id="welcome-hero-title" class="wd-title">
          Tu camino <br class="br-m">hacia <br class="br-t">tu casa <br class="br-d"><br class="br-m"><span class="hl">ya comenzó.</span>
        </h1>
        <p class="wd-body">
          Ahora formas parte de HIR Casa.<br>
          Aquí puedes dar seguimiento <br class="br-m">a tu proceso, <br class="br-d">entender cada etapa <br class="br-m">y tomar decisiones con claridad.
        </p>
      </div>

      <ul class="hero__items">
        <li v-for="item in items" :key="item.text">
          <img :src="item.icon" alt="" aria-hidden="true">
          <span class="wd-body">{{ item.text }}</span>
        </li>
      </ul>
    </div>

    <picture class="hero__media">
      <source media="(max-width: 599px)" :srcset="heroMobile">
      <img :src="heroDesktop" alt="Familia revisando los planos de su nuevo hogar">
    </picture>
  </section>
</template>

<script setup lang="ts">
import heroDesktop from '../../../assets/bienvenida-desktop/hero.jpg'
import heroMobile from '../../../assets/bienvenida-desktop/hero-mobile.jpg'
import iconVisibilidad from '../../../assets/bienvenida-desktop/icon-visibilidad.svg'
import iconAcompanamiento from '../../../assets/bienvenida-desktop/icon-acompanamiento.svg'
import iconDecisiones from '../../../assets/bienvenida-desktop/icon-decisiones.svg'

const items = [
  { icon: iconVisibilidad, text: 'Sabes en qué etapa estás' },
  { icon: iconAcompanamiento, text: 'Tienes acompañamiento en todo momento' },
  { icon: iconDecisiones, text: 'Puedes tomar decisiones informadas' }
]
</script>

<style scoped>
.hero {
  display: flex;
  align-items: stretch;
  height: 512px;
  overflow: hidden;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

.hero__content {
  display: flex;
  flex: 0 0 493px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-6);
  padding: var(--ds-space-6) var(--ds-space-5);
  box-sizing: border-box;
}

.hero__tag {
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.hero__text { display: flex; flex-direction: column; gap: var(--ds-space-3); }
.hero .wd-title .hl { color: #6D59EA; }

.hero__items {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.hero__items li { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 40px; }
.hero__items img { flex: 0 0 40px; width: 40px; height: 40px; }

.hero__media { display: flex; flex: 1 1 0; min-width: 0; }
.hero__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0 24px 24px 0;
}

@media (max-width: 1024px) {
  .hero { height: 544px; }
  .hero__content { flex: 1 1 0; min-width: 0; }
  .hero__media img { border-radius: 0 32px 32px 0; }
}

@media (max-width: 599px) {
  .hero {
    flex-direction: column;
    height: auto;
    gap: var(--ds-space-5);
    padding: var(--ds-space-5) var(--ds-space-4);
  }
  .hero__content { flex: none; gap: var(--ds-space-5); padding: 0; }
  .hero__text { gap: var(--ds-space-4); }
  .hero__media { flex: none; height: 328px; }
  .hero__media img { border-radius: 24px; }
}
</style>
